module.exports = __webpack_public_path__ + "static/media/vayz-banner.2f9b3572.jpg";